import _get from 'lodash/get';
import { call, put } from 'redux-saga/effects';

import { buildThemeWithConfig } from 'utils/branding';
import { fetchBrandingAPI } from 'modules/api/branding';

import * as brandingActions from '../actions';

/**
 * Fetch the broker branding by the `brokerId`.
 *
 * @method fetchBrandingSaga
 * @type   {Generator}
 * @param  {Object}          action The redux action
 * @return {Object|Error}
 */
export function* fetchBrandingSaga(action) {
    try {
        // Extract the `brokerId` from the action
        const { payload: brokerId } = action;
        // Make the call to fetch the branding with the given `brokerId`
        const resp = yield call(fetchBrandingAPI, brokerId);
        // Extract the branding config from the valid response
        const config = _get(resp, 'data.branding', {});
        // Build the theme using the config from the previous response
        const theme = buildThemeWithConfig(config);
        // Build the branding
        const branding = { config, theme };
        // Dispatch the `fetchBranding`.
        yield put(brandingActions.fetchBranding.success(branding));
        // return the branding.
        return branding;
    } catch (error) {
        // Dispatch the error action.
        yield put(brandingActions.fetchBranding.error(error));
        // Return the error.
        return error;
    }
}

/**
 * Reset the broker branding back to the default Mineral branding.
 *
 * @method resetBrandingSaga
 * @type   {Generator}
 * @param  {Object}          action The redux action
 * @return {Object|Error}
 */
export function* resetBrandingSaga() {
    try {
        // Reset the branding back to original.
        const theme = buildThemeWithConfig();
        // Build the branding
        const branding = { config: {}, theme };
        // Dispatch the `resetBranding` action.
        yield put(brandingActions.resetBranding.success(branding));
        // return the branding.
        return branding;
    } catch (error) {
        // Dispatch the error action.
        yield put(brandingActions.resetBranding.error(error));
        // Return the error.
        return error;
    }
}
